import PropTypes from 'prop-types';
import { deprecatedComponent } from '../core/deprecated-component.js';
import { createComponent } from '../core/create-component.js';

const propTypes = {
    /**
   * The visual style of the StandardTileName
   * Available options: "standard", "cta"
   */ skin: PropTypes.oneOf([
        'standard',
        'cta'
    ])
};
/**
 * @subcomponent SecondaryTile
 * @deprecated Use Standard Tile instead, which provides a better user experience.
 */ const SecondaryTileName = deprecatedComponent({
    displayName: 'SecondaryTileNameWithPrice',
    description: 'SecondaryTileNameWithPrice is deprecated; use Standard Tile instead, which provides a better user experience.',
    root: createComponent({
        displayName: 'SecondaryTileName',
        root: 'div',
        propTypes,
        propConfig: {
            classNames (props) {
                const classesSet = new Set([
                    'swan-secondary-tile-name'
                ]);
                if (props.skin === 'cta') classesSet.add('swan-secondary-tile-name-cta');
                return classesSet;
            }
        }
    })
});
SecondaryTileName.defaultProps = {
    skin: 'standard'
};

export { SecondaryTileName };
